import React, { useEffect, useMemo, useState } from 'react';

import CoinCard from './CoinCard';
import _ from '../services/comparators';
import auth from '../services/auth';

import '../css/moving-alerts-list.css';

function MovingAlertsList(props) {
  const filterAlerts = (alerts, filters) => {
    if (!alerts) return;

    var filteredAlerts = alerts.filter(a => props.coins.map(c => c.coin).includes(a.coin)).map(a => {
      const coin = props.coins.find(c => c.coin === a.coin)
      return {
        ...a,
        ...coin
      }
    })

    if (filters.search !== '' && filters.search !== '$$$'){
      filteredAlerts = filteredAlerts.filter(a => a.coin.includes(filters.search))
    }

    if (filters.sort.rank[0] === 1){
      return (filters.sort.rank[1] === 1) ? filteredAlerts.sort(_.byRank) : filteredAlerts.sort(_.byRankDesc)
    }

    if (filters.sort._1h[0] === 1){
      return (filters.sort._1h[1] === 1) ? filteredAlerts.sort(_.by1h) : filteredAlerts.sort(_.by1hDesc)
    }

    if (filters.sort._24h[0] === 1){
      return (filters.sort._24h[1] === 1) ? filteredAlerts.sort(_.by24h) : filteredAlerts.sort(_.by24hDesc)
    }

    if (filters.sort._7d[0] === 1){
      return (filters.sort._7d[1] === 1) ? filteredAlerts.sort(_.by7d) : filteredAlerts.sort(_.by7dDesc)
    }

    if (filters.sort._30d[0] === 1){
      return (filters.sort._30d[1] === 1) ? filteredAlerts.sort(_.by30d) : filteredAlerts.sort(_.by30dDesc)
    }

    if (filters.sort.rsi[0] === 1){
      return (filters.sort.rsi[1] === 1) ? filteredAlerts.sort(_.byRSI) : filteredAlerts.sort(_.byRSIDesc)
    }

    if (filters.sort.rsi_1d[0] === 1){
      return (filters.sort.rsi_1d[1] === 1) ? filteredAlerts.sort(_.byRSI_1D) : filteredAlerts.sort(_.byRSI_1D_Desc)
    }

    if (filters.sort.timestamp[0] === 1){
      return (filters.sort.timestamp[1] === 1) ? filteredAlerts.sort(_.byTimestamp) : filteredAlerts.sort(_.byTimestampDesc)
    }

    return filteredAlerts.sort(_.byTimestamp)
  }

  const [filteredAlerts, setFilteredAlerts] = useState(filterAlerts(props.alerts, props.filters))

  useEffect(() => {
    setFilteredAlerts(filterAlerts(props.alerts, props.filters))
  }, [props.coins, props.filters, props.alerts])

  const itemHeight = props.itemHeight || 110;
  const visibleCount = props.visibleCount || 3;
  const durationMs = props.durationMs || 14000;
  const pauseOnHover = props.pauseOnHover !== undefined ? props.pauseOnHover : true;
  const [isPaused, setIsPaused] = useState(false);

  const renderedAlerts = useMemo(() => {
    if (!filteredAlerts || filteredAlerts.length === 0) {
      return [];
    }

    const alertsWithCoins = filteredAlerts.map(alert => ({
      ...alert,
      coinData: props.coins.find(c => c.coin === alert.coin)
    }));

    return alertsWithCoins.concat(alertsWithCoins);
  }, [filteredAlerts, props.coins]);

  const scrollDistance = filteredAlerts ? filteredAlerts.length * itemHeight : 0;
  const shouldAnimate = filteredAlerts && filteredAlerts.length > visibleCount;

  return (
    <div className="relative">
      <div
        className="moving-alerts-container"
        style={{ height: `${visibleCount * itemHeight}px` }}
        onMouseEnter={() => { if (pauseOnHover) { setIsPaused(true); } }}
        onMouseLeave={() => { if (pauseOnHover) { setIsPaused(false); } }}
      >
        {renderedAlerts.length > 0 && (
          <div
            className={`moving-alerts-track ${shouldAnimate ? 'moving-alerts-track--animate' : ''}`}
            style={{
              animationDuration: `${durationMs}ms`,
              animationPlayState: isPaused ? 'paused' : 'running',
              '--moving-alerts-distance': `${scrollDistance}px`
            }}
          >
            {renderedAlerts.map((alert, index) => (
              <div key={`${alert.coin}-${index}`} className="moving-alerts-item" style={{ /*minHeight: `${itemHeight}px`*/ }}>
                <CoinCard
                  isMobile={props.isMobile}
                  hideForFree={(index % filteredAlerts.length) > 4 && !auth.isUnlocked() && !props.landing}
                  small={props.small}
                  isAlert={true}
                  coin={alert.coinData}
                  signal={alert}
                  onCoinSelected={(coinSymbol) => {
                    props.onCoinSelected(coinSymbol)
                  }}
                ></CoinCard>
              </div>
            ))}
          </div>
        )}
        {filteredAlerts && filteredAlerts.length === 0 && (
          <div className="my-4 text-center">
            <div className="text-muted my-2">
              <span className="dashed">No{(props.portfolioView) ? ' Portfolio ' : ' '}Alerts for Last 24h</span>
            </div>
            <div>
              <img className="svg-container" src="https://img.icons8.com/fluency/96/000000/fire-alarm-button.png"/>
            </div>
          </div>
        )}
      </div>
      <div
        className="pointer-events-none absolute left-0 right-0 top-0 h-3"
        style={{
          backdropFilter: 'blur(3px)',
          background: 'linear-gradient(to bottom, rgba(255,255,255,0.9), rgba(255,255,255,0))'
        }}
      />
      <div
        className="pointer-events-none absolute left-0 right-0 bottom-0 h-3"
        style={{
          backdropFilter: 'blur(3px)',
          background: 'linear-gradient(to top, rgba(255,255,255,0.9), rgba(255,255,255,0))'
        }}
      />
    </div>
  );
}

MovingAlertsList.defaultProps = {
  isHistory: false,
  filters: {
    sort: {
      rank: [0,0],
      _1h: [0,0],
      _24h: [0,0],
      _7d: [0,0],
      _30d: [0, 0],
      rsi: [0,0],
      rsi_1d: [0,0],
      timestamp: [1, 1]
    },
    view: {
      list: false,
      heatmap: true,
      alerts: false
    },
    search: ''
  }
};

export default MovingAlertsList;
